import { Button, Select } from 'antd';
import { useState } from 'react';
import { FileUpload } from '../../../../../shared/features/uploads/components/FileUpload';
import type { UploadView } from '../../../../../shared/features/uploads/uploads.api';

interface ReadinessDocumentAttachProps {
  jobId: string;
  attachments: UploadView[];
  disabled: boolean;
  onAttach: (uploadId: string) => Promise<void>;
}

function attachmentLabel(attachment: UploadView): string {
  return `Attached ${new Date(attachment.confirmedAt ?? attachment.createdAt).toLocaleString()}`;
}

/** Tags an already-confirmed attachment, or uploads a new one and tags it straight away — a not-met document item on the readiness checklist (gitaumoses4/chukua#36). */
export function ReadinessDocumentAttach({ jobId, attachments, disabled, onAttach }: ReadinessDocumentAttachProps) {
  const [selected, setSelected] = useState<string | undefined>(undefined);
  const [tagging, setTagging] = useState(false);

  async function tagSelected() {
    if (!selected) return;
    setTagging(true);
    try {
      await onAttach(selected);
      setSelected(undefined);
    } finally {
      setTagging(false);
    }
  }

  return (
    <div className="flex flex-col gap-2">
      {attachments.length > 0 && (
        <div className="flex items-center gap-2">
          <Select
            className="min-w-64"
            placeholder="Tag a file already attached to this job"
            disabled={disabled || tagging}
            value={selected}
            onChange={setSelected}
            options={attachments.map((attachment) => ({ value: attachment.id, label: attachmentLabel(attachment) }))}
          />
          <Button size="small" disabled={disabled || !selected} loading={tagging} onClick={tagSelected}>
            Tag
          </Button>
        </div>
      )}
      {!disabled && <FileUpload entityType="job" entityId={jobId} onUploaded={(upload) => onAttach(upload.id)} />}
    </div>
  );
}
